"use client"
import React, { FC, useCallback, useRef } from "react"
import { useTypedSelector } from "store"
import styled, { createGlobalStyle } from "styled-components"
import { HEADER_ANIME_D, HEADER_ANIME_M } from "theme/shared"
import { LayoutProvider, useLayoutContext } from "./LayoutContext"

const GlobalStyle = createGlobalStyle`
  :root,
  body,
  #__next {
    height: 100%;
  }

  #__next {
    display: flex;
    flex-direction: column;
    ${(p) => p.theme.breakpoints.up("md")} {
      overflow: hidden;
    }
  }
`
const SkipMainLink = styled.a`
  top: -999px;
  position: absolute;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: -999;

  :focus,
  :active {
    color: ${(p) => p.theme.colors.white};
    background-color: ${(p) => p.theme.colors.darkBlack};
    left: auto;
    top: auto;
    width: 30%;
    height: auto;
    overflow: auto;
    margin: 10px 35%;
    padding: 5px;
    border-radius: 15px;
    border: 4px solid ${(p) => p.theme.colors.mazdaRed};
    text-align: center;
    font-size: 1.2em;
    z-index: 1200;
  }
`
export const StyledMain = styled.div<{ $isShowRoomsScreens?: boolean }>`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-top: ${HEADER_ANIME_M}px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: ${(p) =>
      p.$isShowRoomsScreens ? `0px` : `${HEADER_ANIME_D}px`};
  }
`

const Layout: FC<any> = ({ children }) => {
  const { focusMain, setMainRef, isShowRoomsScreens } = useLayoutContext()

  const mainRef = useRef<HTMLDivElement | null>(null)
  const mainCallbackRef = useCallback(
    (node: HTMLDivElement | null) => {
      mainRef.current = node
      if (node) setMainRef(node)
    },
    [setMainRef]
  )

  const { selectedDetailingCode } = useTypedSelector((state) => state.detailing)
  const { selectedColorCode } = useTypedSelector((state) => state.color)

  return (
    <>
      <GlobalStyle />

      <SkipMainLink
        href=""
        onClick={(event) => {
          event.preventDefault()

          focusMain()
        }}
      >
        דלג לתוכן המרכזי
      </SkipMainLink>

      <StyledMain
        $isShowRoomsScreens={isShowRoomsScreens}
        id="mainTwo"
        tabIndex={-1}
        ref={mainCallbackRef}
      >
        {children}
      </StyledMain>

      {/* For Facebook marketing: */}
      <div
        id="product-id"
        data-id={`${selectedDetailingCode}_${selectedColorCode}`}
        style={{ display: "none" }}
      ></div>
    </>
  )
}

const _Layout: React.FC<any> = (props) => (
  <LayoutProvider>
    <Layout {...props} />
  </LayoutProvider>
)

export default _Layout
